import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriProductCarouselComponent } from '../../components/gonvarri-product-carousel/gonvarri-product-carousel.component';
import { GonvarriProductCarouselItemComponent } from '../../components/gonvarri-product-carousel-item/gonvarri-product-carousel-item.component';
import {CmsConfig, I18nModule, provideConfig, UrlModule} from "@spartacus/core";
import {CarouselModule, MediaModule} from "@spartacus/storefront";
import {RouterLink} from "@angular/router";
import {GonvarriAddToCartModule} from "../gonvarri-add-to-cart/gonvarri-add-to-cart.module";
import {GonvarriChapaQuantityModule} from "../gonvarri-chapa-quantity/gonvarri-chapa-quantity.module";
import {GonvarriProductGridItemModule} from "../gonvarri-product-grid-item/gonvarri-product-grid-item.module";

@NgModule({
  declarations: [
    GonvarriProductCarouselComponent,
    GonvarriProductCarouselItemComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    I18nModule,
    MediaModule,
    RouterLink,
    UrlModule,
    GonvarriAddToCartModule,
    GonvarriChapaQuantityModule,
    GonvarriProductGridItemModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductCarouselComponent: {
          component: GonvarriProductCarouselComponent,
        },
      },
    }),
  ],
})
export class GonvarriCarouselModule { }
